module.exports = __webpack_public_path__ + "static/img/StudentRank3.bb7b1056.png";